import type { ReactNode } from 'react';
import classNames from 'classnames';
import './AppButton.scss';

export type AppButtonVariant = 'primary' | 'outline';

export type AppButtonSharedProps = {
  children?: ReactNode;
  title?: string;
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  className?: string;
  variant?: AppButtonVariant;
};

type ContentProps = {
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  children?: ReactNode;
};

export function appButtonClassName(className?: string, variant?: AppButtonVariant) {
  return classNames('app-button', variant && `app-button--${variant}`, className);
}

export function AppButtonContent({ icon, iconPosition = 'left', children }: ContentProps) {
  return (
    <>
      {iconPosition === 'left' ? icon : null}
      <span>{children}</span>
      {iconPosition === 'right' ? icon : null}
    </>
  );
}
